import React, { Component } from 'react'
import { FlatList, View, StyleSheet } from 'react-native'

export default class ListWrapper extends Component {
  static defaultProps = {
    numberOfColumns: 1,
  }

  listRef = list => {
    this._list = list
  }

  renderItem = ({ item, index, isMasonry = false }) => {
    const { renderItem } = this.props

    const viewProps = { style: styles.listItem }

    if (isMasonry) {
      viewProps.key = this.keyExtractor(item)
    }

    if (!item || item.empty) {
      return <View {...viewProps} />
    }

    return <View {...viewProps}>{renderItem({ item, index })}</View>
  }

  getColumns() {
    const { data, numberOfColumns, pageSize } = this.props
    const columns = []

    const pageData = pageSize && pageSize > 0 ? data.slice(0, pageSize) : data

    for (let i = 0; i < pageData.length; i += numberOfColumns) {
      for (let j = 0; j < numberOfColumns; j += 1) {
        const pos = i + j

        if (!columns[j]) {
          columns[j] = []
        }

        if (pageData[pos]) {
          columns[j].push(pageData[pos])
        }
      }
    }

    return columns
  }

  getData() {
    let { data, numberOfColumns, pageSize } = this.props

    if (pageSize && pageSize > 0) {
      data = data.slice(0, pageSize)
    }

    if (data.length % numberOfColumns !== 0) {
      const padCount = numberOfColumns - (data.length % numberOfColumns)
      data = data.slice()

      for (let i = 0; i < padCount; i += 1) {
        data.push({ empty: true, key: `pad-${i}` })
      }
    }
    return data
  }

  keyExtractor = itm => {
    return String(itm.id)
  }

  render() {
    const { numberOfColumns, listKey, object } = this.props
    const columns = this.getColumns()
    const { rowMargin } = object.attributes

    const gutterWidth = rowMargin
    const gutterStyles = [styles.gutter, { width: gutterWidth }]

    if (numberOfColumns === 1 || !object.attributes.masonry) {
      return (
        <FlatList
          ref={this.listRef}
          data={this.getData()}
          keyExtractor={this.keyExtractor}
          listKey={listKey}
          renderItem={this.renderItem}
          showsVerticalScrollIndicator={false}
          numColumns={numberOfColumns}
          key={`columns-${numberOfColumns}`}
        />
      )
    } else {
      return (
        <View style={styles.wrapper}>
          {columns
            .map((column, index) => {
              const columnKey = `${object.id}__column__${index}`
              const isLastColumn = index === numberOfColumns - 1
              let gutter = null

              if (!isLastColumn) {
                const gutterKey = `${object.id}__gutter__${index}`
                gutter = (
                  <View
                    key={gutterKey}
                    style={gutterStyles}
                    pointerEvents="box-none"
                  />
                )
              }

              return [
                <View key={columnKey} style={styles.column}>
                  {column.map(item =>
                    this.renderItem({ item, isMasonry: true })
                  )}
                </View>,
                gutter,
              ]
            })
            .flat()
            .filter(Boolean)}
        </View>
      )
    }
  }
}

const styles = StyleSheet.create({
  wrapper: {
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
  gutter: {
    flexDirection: 'column',
  },
  column: {
    flexDirection: 'column',
    flex: 1,
  },
  listItem: {
    flex: 1,
    alignItems: 'stretch',
  },
})
